// removed by extract-text-webpack-plugin
module.exports = {"about":"src-components-AboutModal----AboutModal-module---about---3qxVh","column":"src-components-AboutModal----AboutModal-module---column---3h3Zc","aboutHeader":"src-components-AboutModal----AboutModal-module---aboutHeader---Di3It","mediumItalic":"src-components-AboutModal----AboutModal-module---mediumItalic---1-FzQ","aboutImg":"src-components-AboutModal----AboutModal-module---aboutImg---3co-F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutModal/AboutModal.module.scss
// module id = 120
// module chunks = 29990747609436 213534597649335